/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import moment from "moment";
import Link from "next/link";
import router from "next/router";
import { formatCurrency } from "utils/generic-utils";
import { Arrow, CustomButton } from "../summer-camp.style";

const SummerCard = ({ el }) => {
   return (
      <div
         style={{ cursor: "pointer" }}
         onClick={() => router.push(`/summer-camp/${el.id}`)}
         className="summer-card"
         key="id"
      >
         <div className="image-div">
            <img src={el.imageUrl} alt="banner" />
         </div>
         <div className="content-div">
            <div>
               <p className="title">{el.name}</p>
               <p className="desc" dangerouslySetInnerHTML={{ __html: el.description }} />
               <p className="duration">Duration: {el.duration}</p>
               <p className="age">
                  Age Group: {el?.minAge} {el?.minAge && "-"} {el?.maxAge}{" "}
                  {el?.minAge && el?.maxAge && "years"}
               </p>
               <p className="age">Program fee: {formatCurrency(el.applicationFee, "NGN")}</p>
               <p className="age">
                  Start Date: {el?.startDate ? moment(el?.startDate).format("DD-MM-YYYY") : ""}
               </p>
            </div>
            <div className="action-div">
               <Link href={`/summer-camp/${el.id}`} passHref>
                  <div className="link">
                     <p>Explore</p>
                     <Arrow />
                  </div>
               </Link>
               <CustomButton
                  type="button"
                  variant="primary"
                  style={{ height: "3.6rem", width: "10.8rem" }}
               >
                  Apply
               </CustomButton>
            </div>
         </div>
      </div>
   );
};

export default SummerCard;
